module.exports = __webpack_public_path__ + "img/md-item02.af525cf.png";